import { isValidArray, tr } from 'mmfintech-commons'
import { extractBankName, extractBankNameDomestic } from 'mmfintech-checkout-commons'

import BankIcon from './BankIcon'
import SelectBankItem from './SelectBankItem'

import type { SupportedBank, UseFilteredBanksOutput } from 'mmfintech-checkout-commons/types'

import './selectBank.scss'

type SelectBankProps = {
  loading?: boolean
  banksLoaded: boolean
  filteredBanks: UseFilteredBanksOutput
  selectedBankId: string
  onContinue: () => void
}

const SelectBank = (props: SelectBankProps) => {
  const { loading, banksLoaded, filteredBanks, selectedBankId, onContinue } = props

  const handleBankClick = (bank: SupportedBank): void => {
    if (selectedBankId === bank.bankChoiceId) {
      onContinue()
    } else {
      filteredBanks.handleSelectBank(bank)
    }
  }

  if (!banksLoaded) {
    return null
  }

  if (isValidArray(filteredBanks.banks) || !filteredBanks.treeMode) {
    return (
      <div className='select-bank-pane-wrapper'>
        <div className='select-bank-container'>
          {filteredBanks.hasBack && (
            <SelectBankItem
              back
              selected
              data-test='banks-back'
              onClick={filteredBanks.handleBack}
              caption={extractBankName(filteredBanks.selectedGroup)}
              description={extractBankNameDomestic(filteredBanks.selectedGroup)}
              loading={loading}
            />
          )}

          {isValidArray(filteredBanks.banks) ? (
            filteredBanks.banks.map((bank: SupportedBank) => (
              <SelectBankItem
                key={bank.bankChoiceId}
                caption={extractBankName(bank)}
                description={extractBankNameDomestic(bank)}
                selected={selectedBankId === bank.bankChoiceId}
                onClick={() => handleBankClick(bank)}
                icon={<BankIcon bank={bank} />}
                data-test={`bank-${bank.bankChoiceId}`}
                loading={loading}
                maintenance={bank.underMaintenance}
                className={filteredBanks.hasBack ? 'bank-inner' : ''}
              />
            ))
          ) : !filteredBanks.treeMode ? (
            <div className='select-bank-error-wrapper' data-test='error-text'>
              {filteredBanks.bankSearchText?.length > 2
                ? tr('CHECKOUT.PAYMENT.NO_BANKS_FOUND', 'No banks found')
                : tr('CHECKOUT.PAYMENT.SEARCH_BANK_HINT', 'Type 3 or more characters to filter banks…')}
            </div>
          ) : null}
        </div>
      </div>
    )
  }

  if (filteredBanks.treeMode) {
    return (
      <div className='select-bank-error-wrapper no-margin' data-test='error-text'>
        {tr('CHECKOUT.PAYMENT.NO_BANKS.MESSAGE', 'No banks available')}
      </div>
    )
  }

  return null
}

export default SelectBank
